"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ReviewCard } from "./ReviewCard";
interface Review {
  id: string;
  name: string;
  avatar?: string | null;
  rating: number;
  content: string;
  date: string;
  sourceUrl?: string;
}
interface SenjaReviewsClientProps {
  reviews: Review[];
  initialDisplayCount?: number;
}
export const SenjaReviewsClient = t0 => {
  const $ = _c(17);
  const {
    reviews,
    initialDisplayCount: t1
  } = t0;
  const initialDisplayCount = t1 === undefined ? 9 : t1;
  const [displayCount, setDisplayCount] = useState(initialDisplayCount);
  let handleLoadMore;
  let hasMore;
  let t2;
  let t3;
  if ($[0] !== displayCount || $[1] !== reviews) {
    const visibleReviews = reviews.slice(0, displayCount);
    hasMore = displayCount < reviews.length;
    let t4;
    if ($[6] !== reviews.length) {
      t4 = () => {
        setDisplayCount(prev => Math.min(prev + 9, reviews.length));
      };
      $[6] = reviews.length;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    handleLoadMore = t4;
    t2 = "grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3";
    t3 = visibleReviews.map(_temp);
    $[0] = displayCount;
    $[1] = reviews;
    $[2] = handleLoadMore;
    $[3] = hasMore;
    $[4] = t2;
    $[5] = t3;
  } else {
    handleLoadMore = $[2];
    hasMore = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== handleLoadMore || $[12] !== hasMore) {
    t5 = hasMore && <div className="flex justify-center pt-2"><button onClick={handleLoadMore} className="rounded border border-gray-200 bg-white px-2 py-1 text-sm text-gray-700 shadow-sm transition-colors hover:bg-gray-50">Load more</button></div>;
    $[11] = handleLoadMore;
    $[12] = hasMore;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t4 || $[15] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
function _temp(review) {
  return <ReviewCard key={review.id} testimonial={review} />;
}